app
  .controller("ContactusBoxController", [
    "$scope",
    "$localStorage",
    function ($scope, $localStorage) {
        $scope.contactNumber = "";
        $scope.contactEmail = "";
        $scope.contactAddress = "";
        $scope.contactText = "";
    
        let microsite = JSON.parse($localStorage.microsite);
        let siteConfig = microsite.microsite;

        if (
          siteConfig.contactPhone != undefined &&
          siteConfig.contactPhone != null &&
          siteConfig.contactPhone != ""
        ) {
          $scope.contactPhone = siteConfig.contactPhone;
        }
    
        if (
          siteConfig.contactEmail != undefined &&
          siteConfig.contactEmail != null &&
          siteConfig.contactEmail != ""
        ) {
          $scope.contactEmail = siteConfig.contactEmail;
        }
    
        if (
          siteConfig.contactAddress != undefined &&
          siteConfig.contactAddress != null &&
          siteConfig.contactAddress != ""
        ) {
          $scope.contactAddress = siteConfig.contactAddress;
        }
    
        if (
          siteConfig.contactText != undefined &&
          siteConfig.contactText != null &&
          siteConfig.contactText != ""
        ) {
          $scope.contactText = siteConfig.contactText;
        }
    },
  ]);
